import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./auth";
import studentReducer from "./student";
import staffReducer from "./staff";
import institutionReducer from "./institution";
import configurationReducer from "./configuration";

import courseReducer from "./course";
import historicalReducer from "./historical";
import semesterReducer from "./semester";
import subjectReducer from "./subject";
import studentLeaveReducer from "./studentLeave";
import circularReducer from "./circular";
import dashboardReducer from "./dashboard";
import reportReducer from "./report";
import attendanceReducer from "./attendance";
import examAndGradeReducer from "./examAndGrade";
import assignmentReducer from "./assignment";
import lend from "./lend";
import arrival from "./arrival";
import myClassReducer from "./classes";
import notificationReducer from "./notification";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

const VERSION = 4;
const PERSIST_KEY = `hubino_${VERSION}.0.0`;
const persistConfig = {
  key: PERSIST_KEY,
  storage,
  version: VERSION,
  // blacklist: ["examAndGrade"],
  stateReconciler: autoMergeLevel2,
};

const appReducer = combineReducers({
  auth: authReducer,
  student: studentReducer,
  staff: staffReducer,
  course: courseReducer,
  semester: semesterReducer,
  subject: subjectReducer,
  studentLeave: studentLeaveReducer,
  circular: circularReducer,
  dashboard: dashboardReducer,
  report: reportReducer,
  attendance: attendanceReducer,
  examAndGrade: examAndGradeReducer,
  lend: lend,
  arrival: arrival,
  myClass: myClassReducer,
  notification: notificationReducer,
  assignment: assignmentReducer,
  institution: institutionReducer,
  configuration: configurationReducer,
  historical: historicalReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
